import useAccessControl from '../../../legacy/components/AccessControl/useAccessControl'
import { FeatureToggle } from '../../../legacy/contexts/featureToggles/FeatureToggleContext'
import { useAdminControls } from '../../../utils/contexts/admin-controls/AdminControlsContext'
import { useCurrentAccountContext } from '../../../utils/current-account/CurrentAccountContext'
import { ICPlatformVersion } from '../../../utils/ic-platform/versioning/versions.constants'

// IPP Nav V3 release gate. Three independent conditions decide whether the
// new TDS NavigationBar (v3) is reachable; v3 is the unified Nav IA change
// shipping under SFP release R2026_05_0 (Jira epic CXP-208462):
//
//   1. `rt_ipp_nav_v3` (Roulette feature toggle) — per-account opt-in for
//      early access. Treated as an explicit allowlist that bypasses the
//      broader release gate below.
//   2. `ICPlatformVersion.r2026_05_0` — release-dependency gate for the
//      broader rollout, the IPP equivalent of a SFX `release_dependency`.
//      Internal users always pass.
//   3. `useTdsNav` (admin controls, persisted in localStorage) — per-browser
//      beta switch flipped by NavVersionSwitcherButton during R5 rollout.
//
// `eligible` (1 OR 2) gates whether the *opt-in surface* is shown — e.g. the
// NavVersionSwitcherButton or any future admin-modal toggle. Either the
// Roulette allowlist or the R5 release-dependency grants eligibility.
// `enabled` ((1 OR 2) AND 3) gates whether v3 actually renders.
export const useNavV3Gate = () => {
  const { account } = useCurrentAccountContext()
  const hasAccess = useAccessControl()
  const { useTdsNav } = useAdminControls()

  const hasNavV3 = !!account?.featureToggles?.find(f => f.name === FeatureToggle.IppNavV3)
  const canAccessR5 = hasAccess({ minICPlatformVersion: ICPlatformVersion.r2026_05_0 })

  const eligible = hasNavV3 || canAccessR5
  const enabled = eligible && useTdsNav

  return { hasNavV3, canAccessR5, eligible, enabled }
}
